<template>
  <div id="assigningMission">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="100"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>ミッションメンバー選出</b><p>
    <div v-if="isLeader">
      <v-container fluid>
      <p>リーダーはミッションメンバーを<br> <b><u>{{ requiredNums[round] }}名</u></b>選んで下さい．</p>
      <p>あと <b><u>{{ requiredNum - assignedNum }}名</u></b>．</p>

      <v-row class="mx-auto">
        <v-col class="my-n2" v-for="(user, key) in users" v-bind:key="user.name" >
          <v-card class="" elevation=0 max-width=240 min-width=240>
            <div style="text-align:left;">
              <v-simple-table dense >
                <td style="width:90px;padding-top:1px;padding-bottom:1px">
                  <div class="assign-button background-color">
                    <pickButton v-if="isAssigned[key]" v-on:pushed="assign(key)" activeLabel="参加" inactiveLabel="不参加" active='true' />
                    <pickButton v-else v-on:pushed="assign(key)" activeLabel="参加" inactiveLabel="不参加" active='false' />
                  </div>
                </td>
                <td style="padding-left:12px;width:140px">
                  <span class="user-label">{{ users[key].name }}</span>
                </td>
              </v-simple-table>
            </div>
          </v-card>
        </v-col>
      </v-row>

      </v-container>
      <div class="send-button">
        <sendButton v-if="requiredNum>assignedNum" label="ミッションへ行く" active="false"/>
        <sendButton v-else v-on:pushed="assignMission" label="ミッションへ行く" active="true"/>
      </div>

    </div>
    <div v-else>
      <p class="message">リーダー({{ leader.name }})が<br>ミッションメンバーを選出しています．</p>
    </div>

  </v-card>

  </div>
</template>

<script>
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "assigningMission",
  plops: [],
  components: {
    pickButton,
    sendButton
  },
  data() {
    return {
      checkbox1: true,
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      isLeader: this.$store.getters.isLeader,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      users: this.$store.state.userList.users,
      requiredNums: this.$store.state.missionInfo.requiredNums,
      assignedUsers: [],
      isOpen: [],
      selected: [],
      testBool: false,
      isAssigned: [],
      previousSelect: -1,
      dialog: false,
      receivedAssignedUser: [],
    };
  },
  computed: {
    round () {
      return this.$store.state.missionInfo.round
    },
    isAssign : function(num) {
      return this.isAssigned[num]
    },
    assignedNum: function() {
      return this.isAssigned.filter(isAs => isAs==true).length
    },
    requiredNum: function() {
      return this.requiredNums[this.round]
    },
  },
  methods: {
    assign(num) {
      if (this.users[num].isAssigned){
        this.$set(this.users[num], "isAssigned", false)
        // this.users[num].isAssigned = false
        this.$set(this.isAssigned, num, false)
        // this.isAssigned[num] = false
      }else {
        if (this.requiredNums[this.round] <= this.isAssigned.filter(isAs => isAs==true).length){
          // キュー方式
          // for (var i in this.isAssigned){
          //   if (this.isAssigned[i] && (i != this.previousSelect)){
          //     this.$set(this.users[i], "isAssigned", false)
          //     this.$set(this.isAssigned, i, false)
          //   }
          // }
          return
        }
        this.$set(this.users[num], "isAssigned", true)
        // this.users[num].isAssigned = true
        this.$set(this.isAssigned, num, true)
        // this.isAssigned[num] = true
        this.previousSelect = num

      }
    },
    assignMission: function() {
      if (this.requiredNum > this.assignedNum){
        const modalContent = {title: "送信エラー", text: "ミッションメンバーの人数が足りません．"}
        this.$emit('show-modal', modalContent)
        return
      }
      var assignedIds = []
      for (var i in this.isAssigned){
        if (this.isAssigned[i]){
          assignedIds.push(this.users[i].id)
        }
      }
      this.$emit("send-request", {"action": "assign-mission", "roomId": this.roomId, "userId": this.userId, data: {"assigned": assignedIds}})
    },
    open(idx) {
      this.isOpen[idx] = !this.isOpen[idx];
    }
  },
  created() {
    this.$store.commit('setVoting')
    for (var i=0; i<this.users.length; i++ ){
      this.users[i].isAssigned = false
      this.isAssigned.push(false)
    }

    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      self.receivedAssignedUser = self.$store.getters.getUsersByIds(res.data.assigned)
      self.$store.commit('setAssignedUsers', self.receivedAssignedUser)
      console.log(self.$store.state.missionInfo.assignedUsers)

      var snackText = ''
      for (var idx in self.receivedAssignedUser){
        if (idx > 0){
          snackText += '，'
        }
        snackText += self.receivedAssignedUser[idx].name
      }
      snackText += "がリーダーによってミッションメンバーに選ばれました．"
      self.$emit("show-text", {state: "assigning-mission", text: snackText})

      self.dialog = true
      var nextState = "wait-prevoting"
      if (res.state == "wait-prevoting"){
        nextState = "waitPrevoting"
      }else if (res.state == "voting"){
        nextState = "voting"
      }
      self.$emit("proceed-state", nextState)
    }
    console.log(this.requiredNums[this.round])
    for (var j=0; j<this.requiredNums[this.round]; j++ ){
      this.assignedUsers.push("Player " + String(j))
      this.isOpen.push(false)
      console.log(this.assignedUsers)
    }

  }
};
</script>

<style>
/* #assigningMission {
  background-color: rgb(232, 183, 232);
} */

#assigningMission .user-label {
  margin-left: 16px
}

#assigningMission .user-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}

#assigningMission .send-button {
  padding-bottom: 32px
}

#assigningMission .assigning-table {
  align-items: left;
  display: inline-block;
  text-align:center;
}

#assigningMission td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#assigningMission tr {
  /* margin-bottom: 8px */
}

</style>
